import React from 'react';
import Button from '@/components/Button';

// Componente reutilizable para secciones con Imagen y Texto
// Props:
// - title: Título de la sección (string)
// - text: Párrafo descriptivo (string) o children
// - imageUrl: Ruta de la imagen (string)
// - imageAlt: Texto alternativo para la imagen (string)
// - imagePosition: 'left' o 'right' (controla en qué lado aparece la imagen, por defecto 'left')
// - buttonText: Texto para el botón (string, opcional)
// - onButtonClick: Función a ejecutar al hacer clic en el botón (function, opcional)
// - children: Para contenido más complejo en lugar de `text` (ReactNode, opcional)
const ImageTextSection = ({
  title,
  text,
  imageUrl,
  imageAlt,
  imagePosition = 'left', // Imagen a la izquierda por defecto
  buttonText,
  onButtonClick,
  children
}) => {
  const textOrderClass = imagePosition === 'left' ? 'order-1 md:order-2' : 'order-1';
  const imageOrderClass = imagePosition === 'left' ? 'order-2 md:order-1' : 'order-2';

  return (
    <section className="w-full py-16 md:py-20 bg-white">
      <div className="container px-4 md:px-4 mx-auto">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col md:flex-row items-center gap-8 bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-all duration-300">
            {/* Columna de Imagen */}
            <div className={`w-full md:w-2/5 rounded-lg overflow-hidden shadow-md transform hover:scale-105 transition-transform duration-300 ${imageOrderClass}`}>
              <img 
                src={imageUrl || '/images/placeholder.png'} // Imagen por defecto
                alt={imageAlt || title || 'Imagen descriptiva'}
                className="w-full h-auto object-cover"
              />
            </div>
            {/* Columna de Texto */}
            <div className={`w-full md:w-3/5 space-y-6 ${textOrderClass}`}>
              <h3 className="text-2xl font-semibold tracking-tight text-blue-800 mb-4 border-b-2 border-blue-300 pb-2 inline-block">
                {title || 'Título de Sección'}
              </h3>
              {children ? (
                children // Renderizar children si se proporcionan
              ) : (
                <p className="text-blue-700 leading-relaxed text-lg">
                  {text || 'Descripción de la sección...'}
                </p>
              )}
              {buttonText && onButtonClick && (
                <div className="pt-2">
                  <Button
                    variant="default"
                    className="transform hover:scale-105 transition-transform duration-300"
                    onClick={onButtonClick}
                  >
                    {buttonText}
                  </Button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ImageTextSection; 